import React from 'react';
import { OFFER_ANCHOR } from '../data/salesCopy';
export function Footer() {
  return <footer className="bg-brand-ivory px-4 py-6" data-id="element-72" data-mp="3gezf99jl213s">
      <div className="mx-auto max-w-3xl text-center" data-id="element-73" data-mp="3ggk72reij5xy">
        <p className="text-[11px] font-medium leading-snug text-brand-taupe" data-id="element-74" data-mp="32oe11y52qfc8">
          © 2026 YIN YOGA PRO™ — Tous droits réservés. YIN YOGA PRO™ fournit des
          ressources pédagogiques et professionnelles destinées aux professeurs
          de yoga. Il ne remplace pas une formation professionnelle requise, une
          certification, un avis médical, les recommandations applicables ni le
          jugement professionnel du professeur.
        </p>
        <p className="mt-2 text-[11px] font-semibold text-brand-brown" data-id="element-75" data-mp="3lggbgrr4gze1">
          <a href={OFFER_ANCHOR} className="hover:underline" data-id="element-76" data-mp="3qbvmzd1nqj7a">
            Conditions générales
          </a>
          {' • '}
          <a href={OFFER_ANCHOR} className="hover:underline" data-id="element-77" data-mp="2a19qzer4jatl">
            Politique de confidentialité
          </a>
          {' • '}
          <a href={OFFER_ANCHOR} className="hover:underline" data-id="element-78" data-mp="3l90nfv0aswyq">
            Contact
          </a>
        </p>
        <p className="mt-1.5 text-[11px] font-medium text-brand-taupe" data-id="element-79" data-mp="3gb8vx23kfcv2">
          Support :{' '}
          <a href="mailto:kitonline27@gmail.com" className="font-semibold text-brand-brown hover:underline" data-id="element-80" data-mp="3v7zwvfsw0wms">
            kitonline27@gmail.com
          </a>
        </p>
      </div>
    </footer>;
}